export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-243.13d61163.jpg";